/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { DEFAULT_FILTERS, selectFilters } from '@zcode-ui/filters'
import { PROP_NAMES } from '@zcode/mixpanel'
import type { State } from '@zcode/state-type'
import deepequal from 'fast-deep-equal'

import { getMatchingCount } from '../../../inspectors'

import { getFilterPropObject } from './getFilterPropObject'

export const getFilterProps = (state: State) => {
  const filters = selectFilters(state)
  const defaultFilters = DEFAULT_FILTERS

  if (deepequal(filters, defaultFilters)) {
    return {}
  }

  const filterProps = getFilterPropObject(state)
  const matchingCount = getMatchingCount(state)

  return {
    ...filterProps,
    [PROP_NAMES.LISTABLE_COUNT]: matchingCount,
  }
}
